<template>
    <section
        id="about"
        class="relative overflow-hidden py-16 md:py-20 lg:py-24"
    >
        <div class="relative z-10 container">
            <p
                class="mb-4 text-xs font-semibold uppercase tracking-[0.12em] text-[#7d8794] md:mb-3"
            >
                Помогаем эффективно управлять ресурсами компании
            </p>

            <div class="mb-10 flex items-center gap-6 md:mb-14">
                <h2
                    class="shrink-0 text-2xl font-extrabold uppercase leading-none tracking-[-0.04em] text-[#111111] md:md:text-4xl"
                >
                    О компании
                </h2>
                <div class="hidden h-px w-full bg-[#c8d0d8] md:block"></div>
            </div>

            <div class="grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-12 xl:gap-16">
                <!-- Левая колонка -->
                <div class="lg:col-span-7">
                    <div
                        class="relative overflow-hidden rounded-[28px] border border-white/70 bg-bluish/75 p-6 shadow-lg md:p-8 lg:p-10"
                    >
                        <div
                            class="absolute right-0 top-0 h-24 w-24 rounded-full bg-[#ffc400]/10 blur-2xl"
                        ></div>

                        <div class="relative space-y-6 text-[15px] leading-[1.9] text-[#667180] md:text-[16px]">
                            <p>
                                <span class="font-extrabold text-[#111111]">X-DEVS</span>
                                — IT-компания, специализирующаяся на автоматизации
                                бизнес-процессов, разработке CRM и ERP-систем, а также
                                аналитических решений. Мы активно сотрудничаем с
                                поставщиками корпоративных информационных систем, что
                                позволяет обеспечивать комплексный подход к цифровой
                                трансформации бизнеса.
                            </p>

                            <p>
                                Наши клиенты работают в сферах переработки вторсырья,
                                транспортно-грузовой логистики, производства, финансов и
                                других направлений, где важны надёжность, прозрачность
                                процессов и масштабируемость решений.
                            </p>
                        </div>

                        <div class="relative mt-6 md:mt-8">
                            <WeDevelop />
                        </div>
                    </div>
                </div>

                <!-- Правая колонка -->
                <div class="lg:col-span-5">
                    <div class="grid grid-cols-1 gap-4">
                        <div
                            v-for="(item, index) in stats"
                            :key="index"
                            class="group relative overflow-hidden rounded-[24px] border border-white/80 bg-bluish/85 px-5 py-5 shadow-lg transition duration-300 hover:-translate-y-1 md:px-6 md:py-6"
                        >
                            <div
                                class="absolute right-0 top-0 h-20 w-20 rounded-full bg-[#ffc400]/[0.08] blur-2xl transition duration-300 group-hover:bg-[#ffc400]/[0.14]"
                            ></div>

                            <div class="relative flex items-center justify-between gap-4">
                                <div>
                                    <div
                                        class="text-[34px] font-extrabold leading-none tracking-[-0.04em] text-[#f2b300] md:text-[46px]"
                                    >
                                        <template v-if="item.type === 'icon'">
                                            <span aria-hidden="true">∞</span>
                                        </template>
                                        <template v-else>
                                            {{ item.value }}
                                        </template>
                                    </div>
                                </div>

                                <div
                                    class="max-w-[220px] text-right text-[17px] font-extrabold leading-[1.2] text-[#16181d] md:text-[22px]"
                                >
                                    {{ item.label }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script setup>
import WeDevelop from "@js/components/Home/WeDevelop.vue";

const stats = [
    {
        type: 'text',
        value: '7+',
        label: 'Лет на IT рынке',
    },
    {
        type: 'text',
        value: '10+',
        label: 'Отраслевых решений',
    },
    {
        type: 'text',
        value: '20+',
        label: 'Штатных сотрудников',
    },
]
</script>
